import {
	Divider,
	List,
	ListItem,
	ListItemIcon,
	ListItemText,
	Typography,
} from '@material-ui/core';
import {
	Settings as SettingsIcon,
} from '@material-ui/icons';

import LocationsList from '../LocationsList';
import RouterNavLink from '../shared/RouterNavLink';

const DrawerContent = () => (
	<>
		<List>
			<ListItem>
				<Typography variant="body2">Your favourite locations will appear below</Typography>
			</ListItem>
			<ListItem>
				<Typography variant="body2">Add a location using the search icon in the top right</Typography>
			</ListItem>
		</List>

		<Divider />

		<LocationsList />

		<Divider />

		<List disablePadding>
			<ListItem
				button
				component={RouterNavLink}
				to={{
					pathname: '/settings/',
					state: { modal: true },
				}}
			>
				<ListItemIcon>
					<SettingsIcon />
				</ListItemIcon>
				<ListItemText primary="Settings" />
			</ListItem>
		</List>
	</>
);

export default DrawerContent;
